module.exports = __webpack_public_path__ + "static/media/service.9552f59c.svg";